import {store} from '../store/global-store';

const openLoginModal = function() {
    store.commit('openLoginModal');
};

const openInfoModal = function(title, message, trackAction, trackCategory, modalId) {
    store.commit('openInfoModal', {
        active: true,
        title,
        message,
        trackAction,
        trackCategory,
        modalId,
    });
};

export const globalActions = {
    openLoginModal,

    openRegisterModal() {
        openLoginModal();
        store.commit('loginModeSwitch');
    },

    openRegionalSettings() {
        store.commit('openRegionalSettings');
    },

    openRegionSelectModal() {
        store.commit('openRegionSelectModal');
    },

    openInfoModal,

    openReportModal(payload) {
        store.commit('openReportModal', payload);
    },

    submitReportModal(payload) {
        store.commit('submitReportModal', payload);
    },

    openFullscreenModal(src, isAdvert, url) {
        if (isAdvert) {
            store.commit('openPreviewFullscreenModal', {src, url});
        } else {
            store.commit('openFullscreenModal', src);
        }
    },

    openPreview(listingId, listingType, previewUrl) {
        if (store.state.shared.chatOpened) {
            store.commit('openChatPreview', {listingId, listingType, previewUrl});
        } else {
            store.commit('openPreview', {listingId, listingType, previewUrl});
        }
    },

    openBoostModal() {
        store.commit('openBoostModal');
    },

    openLimitInfoModal() {
        store.commit('openLimitInfoModal');
    },

    openFeedback() {
        store.commit('openFeedback');
    },

    autocompleteCallback(result) {
        store.commit('autocompleteCallback', result);
    },

    changeLogoVisibility(result) {
        store.commit('changeLogoVisibility', result);
    },

    openDropdown(dropdownId) {
        store.commit('openDropdown', dropdownId);
    },

    closeDropdown(dropdownId) {
        store.commit('closeDropdown', dropdownId);
    },

    preventShowingEngage(cookieName) {
        store.commit('preventShowingEngage', cookieName);
    },

    handleAjaxErrors(error) {
        if (!error) {
            return;
        }

        let status = error.status;

        if (!status && error.response) {
            status = error.response.status;
        }

        if (status === 401) {
            openLoginModal();
            return;
        }

        if (error.responseJSON && error.responseJSON.title && error.responseJSON.message) {
            openInfoModal(error.responseJSON.title, error.responseJSON.message);
            return;
        }

        const errorsTemplate = document.querySelector('#modal-errors').content;
        let title = errorsTemplate.querySelector('#commonErrorHeader').value;
        let message = errorsTemplate.querySelector('#commonErrorMessage').value;

        if (error.responseJSON && error.responseJSON.errors) {
            const errorsObj = error.responseJSON.errors;
            title = Object.keys(errorsObj)[0];
            message = errorsObj[title];
        } else if (status === 400 && error.responseJSON) {
            title = Object.keys(error.responseJSON)[0];
            message = error.responseJSON[title];
        } else if (status === 403) {
            title = errorsTemplate.querySelector('#notAvailableHeader').value;
            message = errorsTemplate.querySelector('#notAvailableMessage').value;
        } else if (status === 404) {
            title = errorsTemplate.querySelector('#notFoundHeader').value;
            message = errorsTemplate.querySelector('#notFoundMessage').value;
        } else if (error.data && (typeof error.data === 'string' || error.data instanceof String)) {
            message = error.data;
        }

        openInfoModal(title, message);
    },

    triggerTimerTimeout(timeout) {
        store.commit('timerTimeout', timeout);
    },

    changeCommentsCount(commentsCount) {
        store.commit('commentsCount', commentsCount);
    },

    preventShowModals(state) {
        store.commit('preventShowModals', state);
    },

    triggerFilterDeepUpdate(filter) {
        store.commit('filterDeepUpdate', filter);
    },

    markAsViewed(advertId) {
        store.commit('markAsViewed', advertId);
    },

    changePreviewChatIconVisibility(state) {
        store.commit('hidePreviewChatIcon', state);
    },

    changePreselectRegistrationReason(registrationReason) {
        store.commit('changePreselectRegistrationReason', registrationReason);
    },

    setCommentRegistrationPlace(state) {
        store.state.shared.commentRegistrationPlace = state;
    },

    getCommentRegistrationPlace() {
        return store.state.shared.commentRegistrationPlace;
    },

    setMessageRegistrationPlace(state) {
        store.state.shared.messageRegistrationPlace = state;
    },

    getMessageRegistrationPlace() {
        return store.state.shared.messageRegistrationPlace;
    },

    setRateRegistrationPlace(state) {
        store.state.shared.rateRegistrationPlace = state;
    },

    getRateRegistrationPlace() {
        return store.state.shared.rateRegistrationPlace;
    },

    registerAdvertWizard(state) {
        store.commit('registerAdvertWizard', state);
    },

    loginAdvertWizard(state) {
        store.commit('loginAdvertWizard', state);
    },

    showFeedbackButton() {
        store.commit('showFeedbackButton');
    },

    hideFeedbackButton() {
        store.commit('hideFeedbackButton');
    },
};
